<script>
import { mapMutations } from 'vuex';
import LogComp from '@/components/Log/LogComp.vue';

export default {
  components: { LogComp },

  methods: {
    ...mapMutations('logState/logCommonState', ['setIsADType']),
  },
  created() {
    this.setIsADType(true);
  },
  beforeUnmount() {
    this.$route.name !== 'analyticsPage' && this.setIsADType(false);
  },
};
</script>

<template>
  <div>
    <LogComp />
  </div>
</template>

<style lang="scss" scoped></style>
